module.exports = __webpack_public_path__ + "static/media/project8.fe022f0b.png";